(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reporting', {
            parent: 'app',
            url: '/reporting',
            title: 'Reporting',
            sidebarMeta: {
                icon: 'fa fa-pie-chart',
                order: 0
            },
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_RESPONSABLE', 'ROLE_RESPONSABLE_ETABLISSEMENT', 'ROLE_RESPONSABLE_ASSISTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rapport/rapport.html',
                    controller: 'RapportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('eleve');
                    $translatePartialLoader.addPart('sexe');
                    $translatePartialLoader.addPart('statutArchivage');
                    $translatePartialLoader.addPart('parent');
                    $translatePartialLoader.addPart('moyenCommunication');
                    $translatePartialLoader.addPart('abonnement');
                    $translatePartialLoader.addPart('etatAbonnement');
                    $translatePartialLoader.addPart('statutArchivage');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
